const AccountTypeActions = {
  SET_ACCOUNT_CONVERSION_STEP: 'SET_ACCOUNT_CONVERSION_STEP',
  SET_ACCOUNT_CONVERSION_STATUS: 'SET_ACCOUNT_CONVERSION_STATUS'
}

export default AccountTypeActions
